/* eslint-disable import/no-webpack-loader-syntax  */
/* eslint-disable import/no-unresolved */
import React, { Component } from 'react';

import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  ReactAux,
  Header,
  Footer,
  TimeOutMessage,
  Modal,
  Button,
  IconsSolid,
  MainContainer,
  LinkWithIcon,
  ActionsWrapper
} from '@jkhy/vsg-design-system';

import { v4 as guid } from 'uuid';
import userManager from '../../utils/userManager';
import LINKS from '../../utils/links';
import LeftSidebar from '../common/left-sidebar/left-sidebar';
import LoadingPanel from '../common/loading/loading';

import { AppState as AppState_ } from '../../redux/app-state';
import {
  getInternetExplorerVersion,
  goTo404,
  goToIENotSupported,
  isNullOrWhiteSpace
} from '../../utils/helper';
import DocumentPortalSettings_ from '../../data/models/DocumentPortalSettings';
import { BaseType as BaseType_ } from '../common/base-component';
import { getBrowserTabTitle, getDesignTemplateSettings } from '../../redux/actions/setting-actions';
import ResponseBase_ from '../../data/models/ResponseBase';
import { setAntivirusResponse } from '../../redux/actions/anti-virus-actions';
import AntivirusResponseModel_ from '../../data/models/AntivirusResponse';
import { sessionStorageVariables, WorkerActions } from '../../utils/enum';
import { AppDispatch } from '../../data/models/AppDispatch';
import workerUrl from '../worker/counter.worker.ts?worker&url';

const seconds = 60;
const MINUTE_IN_MILLISECONDS = 1000 * 60;

let timeout: number;
let timeoutValue: number;

// Keep client activity in sync between CP and QD; Localestorage related logic.
// Prevent CP to autologout user, while he is using QD
const PUBLIC_APPLICATION_ACTIVITY_KEY = 'pa-activity-timestamp';

type AppProps = {
  browserTitle?: ResponseBase_<string>,
  designSystemTemplate?: ResponseBase_<DocumentPortalSettings_>,
  getBrowserTabTitle: () => void,
  getDesignTemplateSettings: (param) => void,
  setAntivirusResponse: (params: AntivirusResponseModel_) => void,
} & BaseType_;

type AppState = {
  visible: boolean,
  showComponent: boolean,
  showInactiveUserModal: boolean,
  accountVisible: boolean,
  secondsLeft: number
};

// This ugly piece of code is due CORS restriction on Worker creation
// Additional related info
// https://github.com/vitejs/vite/issues/12662
// https://github.com/vitejs/vite/issues/13680
// https://github.com/webpack-contrib/worker-loader/issues/154
// https://web.dev/articles/workers-basics#toc-enviornment-loadingscripts
const js = `import ${JSON.stringify(new URL(workerUrl, import.meta.url))}`;
const blob = new Blob([js], { type: 'application/javascript', });
const objURL = URL.createObjectURL(blob);
const worker = new Worker(objURL, { type: 'module', });
worker.addEventListener('error', (e) => {
  URL.revokeObjectURL(objURL);
});
export class App extends Component<AppProps, AppState> {
  constructor(props) {
    super(props);
    if (getInternetExplorerVersion() !== -1) {
      goToIENotSupported(this.props);
      return;
    }
    if (isNullOrWhiteSpace(window.institutionId)) {
      goTo404(this.props);
      return;
    }
    this.state = {
      visible: false,
      showComponent: false,
      showInactiveUserModal: false,
      accountVisible: false,
      secondsLeft: seconds,
    };

    worker.addEventListener('message', (event) => {
      const { data: { action, value, }, } = event;

      if (action === WorkerActions.counterEnd) {
        this.showInactiveModal(true);
        // start TimeOutMessage countdown
        worker.postMessage({ action: WorkerActions.timeoutComponentCountdown, value: seconds, });
      }
      if (action === WorkerActions.counterResetWithLogicEnd) {
        if (!this.localeStorageActiveTimeStamp()) {
          this.showInactiveModal(true);
          worker.postMessage({ action: WorkerActions.timeoutComponentCountdown, value: seconds, });
        } else this.resetTimer(null, true);
      }
      if (action === WorkerActions.timeoutComponentIntervalValue) {
        this.setState({ secondsLeft: value, });
        if (value <= 0) {
          this.showInactiveModal(false);
          worker.postMessage({ action: WorkerActions.timeoutComponentCountdownIntervalClear, });
          this.logoutOnInactivity();
        }
      }
    });
  }

  async componentDidMount() {
    /* eslint-disable no-shadow */
    const { getBrowserTabTitle, getDesignTemplateSettings, } = this.props;

    await getBrowserTabTitle();

    this.applyCustomTitle();

    await getDesignTemplateSettings(window.institutionId);

    this.addFavicon();

    await this.checkUser();

    this.inactiveUserTime();
  }

  checkUser = async () => {
    await userManager.getUser().then(user => {
      if (user) {
        const { profile, } = user;
        if ((profile || {}).InstitutionId === window.institutionId) {
          this.setState({
            showComponent: true,
          });
        }
      }
    });
  }

  addFavicon = () => {
    const { designSystemTemplate, } = this.props;
    const { faviconUrl, } = { ...designSystemTemplate?.result, };

    const linkNode = document.createElement('link');
    const {
      contentDeliveryNetworkURL,
      institutionId,
      lvApiName,
    } = window;

    let faviconHref = faviconUrl || `/api/branding/${institutionId}/${lvApiName}/withoutModel/favicon`;
    // Check url has domain
    if (faviconHref.indexOf('/api') === 0) faviconHref = `${contentDeliveryNetworkURL}${faviconHref}`;

    linkNode.href = `${faviconHref}?nocache=${guid()}`;
    linkNode.rel = 'shortcut icon';
    linkNode.type = 'image/x-icon';
    document.head.appendChild(linkNode);
  };

  applyCustomTitle = () => {
    const { browserTitle, } = this.props;
    const response = browserTitle || { result: '', };
    // To Do -> Store only result from response, instead of whole response object
    document.title = response.result || 'Document Portal';
  };

  showInactiveModal = value => {
    this.setState({ showInactiveUserModal: value, });
  }

  localeStorageActiveTimeStamp = () => {
    const { App: { InactiveUserMinutes, }, } = window.CONFIG;
    const timeoutPeriod = parseInt(InactiveUserMinutes, 10) * MINUTE_IN_MILLISECONDS;

    const currentTimeStamp = new Date().getTime();
    const loggedActivityTimestamp = parseInt(localStorage.getItem(PUBLIC_APPLICATION_ACTIVITY_KEY), 10);
    const diff = currentTimeStamp - loggedActivityTimestamp;

    return timeoutPeriod > diff;
  }

  logout = () => {
    const { history, } = this.props;
    history.push(LINKS.LOGOUT);
  }

  logoutOnInactivity = () => {
    const { history, } = this.props;

    if (!this.localeStorageActiveTimeStamp()) history.push(`${LINKS.LOGOUT}/1/`);
    else {
      this.showInactiveModal(false);
      this.inactiveUserTime();
    }
  }

  inactiveUserTime = () => {
    const { App: { InactiveUserMinutes, }, } = window.CONFIG;

    //  Disable autologout, case InactiveUserMinutes = 0 or not set
    if (!InactiveUserMinutes || InactiveUserMinutes === '0') return;

    timeoutValue = parseInt(InactiveUserMinutes, 10) * MINUTE_IN_MILLISECONDS;

    worker.postMessage({ action: WorkerActions.counterStart, value: timeoutValue, });
    document.onkeypress = e => this.resetTimer(e, false);
    document.onmousemove = e => this.resetTimer(e, false);
    document.onmousedown = e => this.resetTimer(e, false);
    document.ontouchstart = e => this.resetTimer(e, false);
    document.ontouchmove = e => this.resetTimer(e, false);
    document.onkeydown = e => this.resetTimer(e, false);
  }

  resetTimer = (e: KeyboardEvent | MouseEvent | TouchEvent, dontUpdatePublicAppKey: boolean) => {
    const { showInactiveUserModal, } = this.state;

    worker.postMessage({ action: WorkerActions.counterReset, value: timeout, });
    if (!dontUpdatePublicAppKey) {
      const activityTimestamp = `${new Date().getTime()}`;
      localStorage.setItem(PUBLIC_APPLICATION_ACTIVITY_KEY, activityTimestamp);
    }

    if (!showInactiveUserModal) {
      worker.postMessage({ action: WorkerActions.counterResetWithLogicStart, value: timeoutValue, });
    }
  };

  hideNavMenu = () => {
    this.setState({ visible: false, });
  }

  render() {
    const {
      children,
      antiVirusScanResult,
      setAntivirusResponse,
      designSystemTemplate,
      loading,
      location: { pathname, },
    } = this.props;

    const {
      visible, showInactiveUserModal, showComponent, accountVisible, secondsLeft,
    } = this.state;

    const { authority, } = (window as any).CONFIG.Oidc;

    /* eslint-disable max-len */
    const changePasswordUrl = `${authority}/ChangePassword?returnUrl=${window.BASE_URL}home&institutionId=${(window.institutionId || '')}&lvApiName=${window.lvApiName}`;

    const navMenu = <LeftSidebar onHandleCloseMenu={this.hideNavMenu} />;

    const {
      isLeftSideImageSelected,
      brandName,
      footerBottomText,
      footerLeftImageUrl,
      footerMiddleImageUrl,
      footerRightImageUrl,
      footerTopText,
      financialInstitutionMarketingURL,
      financialInstitutionMarketingTabletViewURL,
      financialInstitutionMarketingMobileViewURL,
    } = { ...designSystemTemplate?.result, };

    const isCurrentRequestsPage = pathname === LINKS.CURRENT_REQUESTS;

    const header = (
      <Header
        logoText={isLeftSideImageSelected ? null : brandName}
        accountBtn={{
          content:
  <div className="mt-2 mb-2 ml-2 mr-2">
    <h3 className="mb-2">Account</h3>
    <p className="mb-2">{sessionStorage.getItem(sessionStorageVariables.userEmail)}</p>
    <LinkWithIcon className="mb-2" icon={IconsSolid.faLockAlt}>
      <a href={changePasswordUrl}>Change password</a>
    </LinkWithIcon>
    <ActionsWrapper directionCol>
      <Button btnType="secondary" iconLeft={IconsSolid.faSignOutAlt} onClick={this.logout}>Sign out now</Button>
    </ActionsWrapper>
  </div>,
          isVisible: accountVisible,
          onOpen: () => { this.setState({ accountVisible: true, }); },
          onClose: () => { this.setState({ accountVisible: false, }); },
        }}
        navMenu={navMenu}
        isMenuVisible={visible}
        onMenuOpen={() => this.setState({ visible: true, })}
        onMenuClose={() => this.setState({ visible: false, })}
        logoSimpleLink={{ path: '/home', }}
        logoAccessibility={{
          title: 'Home',
          ariaLabel: 'Home Page',
        }}
        dataUI="LayoutHeader"
      />
    );

    const footer = (
      <Footer
        version={`${window.FE_VERSION}`}
        imgLeft={{ src: footerLeftImageUrl, alt: '', }}
        imgCenter={{ src: footerMiddleImageUrl, alt: '', }}
        imgRight={{ src: footerRightImageUrl, alt: '', }}
        topText={footerTopText}
        bottomText={footerBottomText}
        dataUI="LayoutFooter"
      />
    );

    return (
      showComponent ? (
        <ReactAux>
          <MainContainer
            isClientPortal
            header={header}
            leftSideElement={navMenu}
            bannerProps={isCurrentRequestsPage ? undefined : {
              desktopImg: financialInstitutionMarketingURL,
              tabletImg: financialInstitutionMarketingTabletViewURL,
              mobileImg: financialInstitutionMarketingMobileViewURL,
              dataUI: 'LayoutBanner',
            }}
            footer={footer}
          >
            {children}

            <TimeOutMessage
              dataUI="autologout-modal"
              isVisible={showInactiveUserModal}
              title="Long inactivity detected"
              subText="We will sign you out to keep your account safe"
              seconds={seconds}
              secondsLeft={secondsLeft}
              onClose={() => this.showInactiveModal(false)}
              buttons={[
                <Button dataUI="still-here-button" className="mb-2" onClick={() => this.showInactiveModal(false)}>I am here</Button>,
                <Button dataUI="sign-out-button" btnType="secondary" onClick={this.logout}>Sign out now</Button>
              ]}
            />

            <Modal
              title="Virus Scan Result"
              isVisible={antiVirusScanResult?.HasThreat}
              onClose={() => { setAntivirusResponse({ HasThreat: false, }); }}
              closeBtnName="Close"
            >
              <p>
                File name:&nbsp;
                <strong>{antiVirusScanResult?.FileName}</strong>
              </p>
              <br />
              <br />
              <p>
                Our anti-virus program has found a threat with your document and has removed the document from upload.
                Please try uploading a new document. If you have any questions, please contact us.
              </p>
            </Modal>

            {loading && <LoadingPanel />}
          </MainContainer>
        </ReactAux>
      )
        : (
          <LoadingPanel />
        )
    );
  }
}

export default withRouter(connect(
  (state: AppState_) => ({
    browserTitle: state.browserTitle,
    designSystemTemplate: state.designSystemTemplate,
    antiVirusScanResult: state.antiVirusScanResult,
    loading: state.loading,
  }),
  (dispatch: AppDispatch) => {
    return {
      getBrowserTabTitle: () => dispatch(getBrowserTabTitle()),
      getDesignTemplateSettings: (param: string) => dispatch(getDesignTemplateSettings(param)),
      setAntivirusResponse: (params: AntivirusResponseModel_) => dispatch(setAntivirusResponse(params)),
    };
  }
)(App));
